var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transactions"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('TxHeader'), _c('TxInteractive', {
    attrs: {
      "transactions": _vm.transactions,
      "assets-loaded": _vm.assetsLoaded,
      "loading": _vm.loading,
      "chains": _vm.chains
    },
    on: {
      "change": _vm.fetchTx
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }